export default "__VITE_ASSET__C$nBcKLL__"